// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608170004/js/" + chunkId + "." + {"44":"2b3654fb","225":"2f2a72d7","481":"0e54c88a","486":"8e2eed99","770":"b1718276"}[chunkId] + ".0.9363784527685387.chunk.js";
};